import { useState } from "react";
import { Badge, Button, Col, Dropdown, Row } from "react-bootstrap";
import { SpendFilterModal } from "./SpendFilterModal";
import { CampaignTypeModal } from "./CampaignTypeModal";
import { StatusFilterModal } from "./StatusFilterModal";
import { SlClose } from "react-icons/sl";
import { LuSettings2 } from "react-icons/lu";
import HelperService from "../../../Services/HelperService";
import { CampaignModal } from "./CampaignModal";
import { AdGroupModal } from "./AdGroupModal";
import { MatchTypeModal } from "./MatchTypeModal";

interface FilterProps {
  filters: any;
  resetObject: any;
  setFilters: (obj: any) => void;
  page_type: string;
}

const FilterMain = ({
  filters,
  resetObject,
  setFilters,
  page_type,
}: FilterProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);
  const [isAdGroupModalOpen, setIsAdGroupModalOpen] = useState(false);
  const [isMatchTypeModalOpen, setIsMatchTypeModalOpen] = useState(false);
  const [spendModalOpen, setSpendModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState<any>("");

  const handleCancelFilter = (type: string) => {
    let localObj = { ...filters };
    switch (type) {
      case "CAMPAIGN":
        localObj.campaign = [];
        break;
      case "AD_GROUP":
        localObj.adGroup = [];
        break;
      case "STATUS":
        localObj.status = [];
        break;
      case "SPEND":
        localObj.spend = {};
        break;
      case "SALES":
        localObj.sales = {};
        break;
      case "ACOS":
        localObj.ACOS = {};
        break;
      case "CLICKS":
        localObj.clicks = {};
        break;
      case "DAILY_BUDGET":
        localObj.budget = {};
        break;
      case "IMPRESSIONS":
        localObj.impressions = {};
        break;
      case "ORDERS":
        localObj.purchases = {};
        break;
      case "BID":
        localObj.bid = {};
        break;
      case "MATCH_TYPE":
        localObj.matchType = [];
        break;
      case "CTR":
        localObj.ctr = {};
        break;

      default:
        break;
    }
    setFilters(localObj);
  };

  const getHeading = (data: any) => {
    switch (data?.compareType) {
      case "equals":
        return `${HelperService.removeSpecialChar(data?.type)}: = ${
          data?.value
        }`;
      case "not_equals":
        return `${HelperService.removeSpecialChar(data?.type)}: != ${
          data?.value
        }`;
      case "less_than":
        return `${HelperService.removeSpecialChar(data?.type)}: < ${
          data?.value
        }`;
      case "less_than_equal":
        return `${HelperService.removeSpecialChar(data?.type)}: <= ${
          data?.value
        }`;
      case "greater_than":
        return `${HelperService.removeSpecialChar(data?.type)}: > ${
          data?.value
        }`;
      case "greater_than_equal":
        return `${HelperService.removeSpecialChar(data?.type)}: > ${
          data?.value
        }`;
      case "between":
        return `${data?.value?.min} <= ${HelperService.removeSpecialChar(
          data?.type
        )} <= ${data?.value?.max}`;
      default:
        return "";
    }
  };

  function isAnyFilterSet() {
    return Object.values(filters).some((value) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === "object" && value !== null) {
        return Object.keys(value).length > 0;
      }
      return Boolean(value);
    });
  }

  return (
    <>
      <div className="d-flex flex-wrap gap-2 mb-3 applied-filters">
        {isAnyFilterSet() && (
          <span className="font-medium font-14">Filters:</span>
        )}
        {filters.campaign && filters.campaign.length > 0 && (
          <Badge className="filter-badge w-auto align-items-center text-wrap d-flex">
            Campaigns:{" "}
            {filters?.campaign?.map((item: any) => item.name).join(", ")}
            <div>
              <SlClose
                className="close ms-2"
                onClick={() => handleCancelFilter("CAMPAIGN")}
              />
            </div>
          </Badge>
        )}
        {filters.adGroup && filters.adGroup.length > 0 && (
          <Badge className="filter-badge w-auto align-items-center text-wrap d-flex">
            Ad Groups:{" "}
            {filters?.adGroup?.map((item: any) => item.name).join(", ")}
            <div>
              <SlClose
                className="close ms-2"
                onClick={() => handleCancelFilter("AD_GROUP")}
              />
            </div>
          </Badge>
        )}
        {filters.status && filters.status.length > 0 && (
          <Badge className="filter-badge">
            Status: {filters.status.join(", ")}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("STATUS")}
            />
          </Badge>
        )}
        {filters.matchType && Object.keys(filters.matchType).length > 0 && (
          <Badge className="filter-badge">
            Match Type: {filters.matchType.join(", ")}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("MATCH_TYPE")}
            />
          </Badge>
        )}
        {filters.spend && Object.keys(filters.spend).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.spend)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("SPEND")}
            />
          </Badge>
        )}
        {filters.sales && Object.keys(filters.sales).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.sales)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("SALES")}
            />
          </Badge>
        )}
        {filters.ACOS && Object.keys(filters.ACOS).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.ACOS)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("ACOS")}
            />
          </Badge>
        )}
        {filters.clicks && Object.keys(filters.clicks).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.clicks)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("CLICKS")}
            />
          </Badge>
        )}
        {filters.budget && Object.keys(filters.budget).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.budget)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("DAILY_BUDGET")}
            />
          </Badge>
        )}
        {filters.impressions && Object.keys(filters.impressions).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.impressions)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("IMPRESSIONS")}
            />
          </Badge>
        )}
        {filters.purchases && Object.keys(filters.purchases).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.purchases)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("ORDERS")}
            />
          </Badge>
        )}
        {filters.bid && Object.keys(filters.bid).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.bid)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("BID")}
            />
          </Badge>
        )}
        {filters.ctr && Object.keys(filters.ctr).length > 0 && (
          <Badge className="filter-badge">
            {getHeading(filters.ctr)}
            <SlClose
              className="close ms-2"
              onClick={() => handleCancelFilter("CTR")}
            />
          </Badge>
        )}
      </div>
      <Row className="mb-3">
        <Col lg={6} style={{ minHeight: "43px" }}>
          <Dropdown className="filter-btn position-absolute">
            <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
              <LuSettings2 size={14} /> Filters
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ maxHeight: "500px", overflowY: "auto" }}>
              <Dropdown.Item onClick={() => setIsCampaignModalOpen(true)}>
                Campaign
              </Dropdown.Item>
              {page_type !== "CAMPAIGN" && page_type !== "PLACEMENTS" && (
                <Dropdown.Item onClick={() => setIsAdGroupModalOpen(true)}>
                  Ad Group
                </Dropdown.Item>
              )}
              {page_type === "CAMPAIGN" && (
                <>
                  <Dropdown.Item
                    onClick={() => {
                      setSpendModalOpen(true);
                      setSelectedType("DAILY_BUDGET");
                    }}
                  >
                    Daily Budget
                  </Dropdown.Item>

                  {/* <Dropdown.Item onClick={() => setIsModalOpen(true)}>
                    Campaign Type
                  </Dropdown.Item> */}
                </>
              )}

              {(page_type === "AD_GROUPS" ||
                page_type === "KEYWORDS" ||
                page_type === "TARGETING" ||
                page_type === "SEARCH_TERM") && (
                <Dropdown.Item
                  onClick={() => {
                    setSpendModalOpen(true);
                    setSelectedType("BID");
                  }}
                >
                  Bids
                </Dropdown.Item>
              )}

              {(page_type === "KEYWORDS" || page_type === "SEARCH_TERM") && (
                <Dropdown.Item
                  onClick={() => {
                    setIsMatchTypeModalOpen(true);
                  }}
                >
                  Match Type
                </Dropdown.Item>
              )}

              {page_type === "PLACEMENTS" && (
                <Dropdown.Item
                  onClick={() => {
                    setSpendModalOpen(true);
                    setSelectedType("CTR");
                  }}
                >
                  CTR
                </Dropdown.Item>
              )}

              {page_type !== "PLACEMENTS" &&
                page_type !== "SEARCH_TERM" &&
                page_type !== "PRODUCT" && (
                  <Dropdown.Item onClick={() => setIsStatusModalOpen(true)}>
                    Status
                  </Dropdown.Item>
                )}

              <Dropdown.Item
                onClick={() => {
                  setSpendModalOpen(true);
                  setSelectedType("SPEND");
                }}
              >
                Spend
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  setSpendModalOpen(true);
                  setSelectedType("SALES");
                }}
              >
                Sales
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  setSpendModalOpen(true);
                  setSelectedType("ACOS");
                }}
              >
                ACOS
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  setSpendModalOpen(true);
                  setSelectedType("CLICKS");
                }}
              >
                Clicks
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  setSpendModalOpen(true);
                  setSelectedType("IMPRESSIONS");
                }}
              >
                Impressions
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  setSpendModalOpen(true);
                  setSelectedType("ORDERS");
                }}
              >
                Orders
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col lg={6} className="text-end">
          {isAnyFilterSet() && (
            <Button
              style={{ height: "33px" }}
              className="btn btn-wmx-secondary"
              disabled={!isAnyFilterSet()}
              onClick={() => setFilters(resetObject)}
            >
              Reset
            </Button>
          )}
        </Col>
      </Row>

      <CampaignModal
        isOpen={isCampaignModalOpen}
        onClose={() => setIsCampaignModalOpen(false)}
        onApply={(selected: any[]) => {
          let localObj = { ...filters };
          localObj.campaign = selected;
          setFilters(localObj);
        }}
        selectedCampaigns={filters.campaign}
      />

      <AdGroupModal
        isOpen={isAdGroupModalOpen}
        onClose={() => setIsAdGroupModalOpen(false)}
        onApply={(selected: any[]) => {
          let localObj = { ...filters };
          localObj.adGroup = selected;
          setFilters(localObj);
        }}
        selectedAdGroups={filters.adGroup}
      />

      <CampaignTypeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onApply={(selected) => {
          let localObj = { ...filters };
          localObj.campaignType = selected;
          setFilters(localObj);
        }}
        selectedTypesProp={filters.campaignType}
      />

      <StatusFilterModal
        isOpen={isStatusModalOpen}
        onClose={() => setIsStatusModalOpen(false)}
        onApply={(statuses) => {
          let localObj = { ...filters };
          localObj.status = statuses;
          setFilters(localObj);
        }}
        selectedStatusProp={filters.status}
      />

      <MatchTypeModal
        isOpen={isMatchTypeModalOpen}
        onClose={() => setIsMatchTypeModalOpen(false)}
        onApply={(selectedTypes) => {
          let localObj = { ...filters };
          localObj.matchType = selectedTypes;
          setFilters(localObj);
        }}
        selectedMatchTypes={filters.matchType}
      />

      <SpendFilterModal
        isOpen={spendModalOpen}
        onClose={() => setSpendModalOpen(false)}
        selectedData={filters}
        type={selectedType}
        onApply={(data: any) => {
          let localObj = { ...filters };
          switch (selectedType) {
            case "SPEND":
              localObj.spend = data;
              break;
            case "SALES":
              localObj.sales = data;
              break;
            case "ACOS":
              localObj.ACOS = data;
              break;
            case "CLICKS":
              localObj.clicks = data;
              break;
            case "DAILY_BUDGET":
              localObj.budget = data;
              break;
            case "IMPRESSIONS":
              localObj.impressions = data;
              break;
            case "ORDERS":
              localObj.purchases = data;
              break;
            case "BID":
              localObj.bid = data;
              break;
            case "CTR":
              localObj.ctr = data;
              break;

            default:
              break;
          }
          setFilters(localObj);
        }}
      />
    </>
  );
};

export default FilterMain;
